<app-nav></app-nav>
<section class="polyclinic">
  <app-click-to-call></app-click-to-call>
  <div class="container">
    <div class="col">
      <div class="modal-body claim-pop text-center mt-4">
        <img src="../../assets/images/doctor.png">
      </div>

      <p class="text-center">Select the specialization below. Basis the availability of slots, you will recieve a
        confirmation on your email.</p>
      <div class="ml-4 mr-4">
        <h6 class="spec-cat"><b>Specialization</b></h6>
        <div class="text-center mb-4 ">

          <button *ngIf="!isMentalHealth" class="btn btn-bordered-blue mt-2"
            (click)="bookAppointment('General Physician');">General Physician</button>
          <button class="btn btn-bordered-grey mt-2" *ngIf="this.specializationType ==='General Physician'"
            (click)="confirmAppointment('General Physician')"
            [disabled]="this.disable || this.hasEcard">Confirm</button>

          <button *ngIf="!isMentalHealth" class="btn btn-bordered-blue mt-2"
            (click)="bookAppointment('Ayurvedic');">Ayurvedic</button>
          <button class="btn btn-bordered-grey mt-2" *ngIf="this.specializationType ==='Ayurvedic'"
            (click)="confirmAppointment('Ayurvedic');" 
            [disabled]="this.disable || this.hasEcard">Confirm</button>

          <button *ngIf="!isMentalHealth" class="btn btn-bordered-blue mt-2"
            (click)="bookAppointment('Covid19');">Covid19</button>
          <button class="btn btn-bordered-grey mt-2" *ngIf="this.specializationType === 'Covid19'"
            (click)="confirmAppointment('Covid19');" 
            [disabled]="this.disable || this.hasEcard">Confirm</button>

          <button *ngIf="!isMentalHealth" class="btn btn-bordered-blue mt-2"
            (click)="bookAppointment('Dentist');">Dentist</button>
          <button class="btn btn-bordered-grey mt-2" *ngIf="this.specializationType === 'Dentist'"
            (click)="confirmAppointment('Dentist');" 
            [disabled]="this.disable || this.hasEcard">Confirm</button>

          <button *ngIf="!isMentalHealth" class="btn btn-bordered-blue mt-2"
            (click)="bookAppointment('Dermatologist');">Dermatologist</button>
          <button class="btn btn-bordered-grey mt-2" *ngIf="this.specializationType === 'Dermatologist'"
            (click)="confirmAppointment('Dermatologist');"
            [disabled]="this.disable || this.hasEcard">Confirm</button>

          <button *ngIf="!isMentalHealth" class="btn btn-bordered-blue mt-2"
            (click)="bookAppointment('Diabetologist');">Diabetologist</button>
          <button class="btn btn-bordered-grey mt-2" *ngIf="this.specializationType === 'Diabetologist'"
            (click)="confirmAppointment('Diabetologist');"
            [disabled]="this.disable || this.hasEcard">Confirm</button>

          <button *ngIf="!isMentalHealth" class="btn btn-bordered-blue mt-2"
            (click)="bookAppointment('Internal Medicine');">Internal Medicine</button>
          <button class="btn btn-bordered-grey mt-2" *ngIf="this.specializationType === 'Internal Medicine'"
            (click)="confirmAppointment('Internal Medicine');"
            [disabled]="this.disable || this.hasEcard">Confirm</button>

          <button *ngIf="!isMentalHealth" class="btn btn-bordered-blue mt-2"
            (click)="bookAppointment('Gynaecologist');">Gynaecologist</button>
          <button class="btn btn-bordered-grey mt-2" *ngIf="this.specializationType === 'Gynaecologist'"
            (click)="confirmAppointment('Gynaecologist');"
            [disabled]="this.disable || this.hasEcard">Confirm</button>

          <button *ngIf="!isMentalHealth" class="btn btn-bordered-blue mt-2"
            (click)="bookAppointment('Homeopathy');">Homeopathy</button>
          <button class="btn btn-bordered-grey mt-2" *ngIf="this.specializationType === 'Homeopathy'"
            (click)="confirmAppointment('Homeopathy');"
            [disabled]="this.disable || this.hasEcard">Confirm</button>

          <button *ngIf="!isMentalHealth" class="btn btn-bordered-blue mt-2"
            (click)="bookAppointment('Ophthalmologist');">Ophthalmologist</button>
          <button class="btn btn-bordered-grey mt-2" *ngIf="this.specializationType === 'Ophthalmologist'"
            (click)="confirmAppointment('Ophthalmologist');"
            [disabled]="this.disable || this.hasEcard">Confirm</button>

          <button *ngIf="!isMentalHealth" class="btn btn-bordered-blue mt-2"
            (click)="bookAppointment('Orthopaedics');">Orthopaedics</button>
          <button class="btn btn-bordered-grey mt-2" *ngIf="this.specializationType === 'Orthopaedics'"
            (click)="confirmAppointment('Orthopaedics');"
            [disabled]="this.disable || this.hasEcard">Confirm</button>

          <button *ngIf="!isMentalHealth" class="btn btn-bordered-blue mt-2"
            (click)="bookAppointment('Paediatrician');">Paediatrician</button>
          <button class="btn btn-bordered-grey mt-2" *ngIf="this.specializationType === 'Paediatrician'"
            (click)="confirmAppointment('Paediatrician');"
            [disabled]="this.disable || this.hasEcard">Confirm</button>

          <button *ngIf="!isMentalHealth" class="btn btn-bordered-blue mt-2"
            (click)="bookAppointment('Unani');">Unani</button>
          <button class="btn btn-bordered-grey mt-2" *ngIf="this.specializationType === 'Unani'"
            (click)="confirmAppointment('Unani');"
            [disabled]="this.disable || this.hasEcard">Confirm</button>

           <!-- Mental Health -->
          <button *ngIf="isMentalHealth" class="btn btn-bordered-blue mt-2"
            (click)="bookAppointment('Psychiatrist Specialization');">Psychiatrist Specialization</button>
          <button class="btn btn-bordered-grey mt-2" *ngIf="this.specializationType ==='Psychiatrist Specialization'"
            (click)="confirmAppointment('Psychiatrist Specialization');"
            [disabled]="this.disable || this.hasEcard">Confirm</button>

        </div>
      </div>
    </div>

  </div>
  <div class="modal fade" id="thankyou" data-keyboard="false" data-backdrop="static">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body claim-pop text-center mt-4">
          <img
            src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/common-icons/done-intimate.jpg">
        </div>
        <center class="sub-title mt-2 ml-4 mr-4">
          <p>Thank You! your request has been placed.</p>
        </center>
        <div class="text-center ml-4 mr-4">
          <p>Basis the availability of the slots, you will receive a confirmation on your email.</p>
        </div>
        <div class="text-center ml-4 mr-4 mb-4">
          <button type="button" class="btn btn-blue" data-dismiss="modal" routerLink="/home">Done</button>
        </div>
      </div>
    </div>
  </div>
</section>

<div id="spinner" [hidden]="!loading">
  <div class="spinnerfull">
    <i class="fa fa-spinner fa-spin fa-3x"></i>
  </div>
</div>